import { useState } from 'react';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';

import { useCosmos } from 'providers/contexts/CosmosContext';
import { hasBetaProgram } from 'utility/experiments';
import { useDashboardContext } from 'screens/dashboard/Dashboard';
import WidgetAlerts from './WidgetAlerts';
import { useWidgetAlertPulse, ALERT_PULSE_ANIMATION } from './useWidgetAlertPulse';
import { useWidgetContext } from '../Widget';

type TWidgetAlertButtonProps = {
  hideAlertButton?: boolean;
};

const WidgetAlertButton = ({ hideAlertButton = false }: TWidgetAlertButtonProps) => {
  const { t } = useTranslation();
  const { sessionConfig, userInfo } = useCosmos();
  const { hasProDataInsights } = useDashboardContext();
  const { widget, chartType } = useWidgetContext();
  const [isAlertDrawerOpen, setIsAlertDrawerOpen] = useState(false);
  const isAlertPulsing = useWidgetAlertPulse(widget?.id);

  const hasBetaAccess = hasBetaProgram(sessionConfig, userInfo);
  const isKpi = chartType === 'kpi';

  // Check if user has access.
  if (!hasProDataInsights || !hasBetaAccess || hideAlertButton) {
    return null;
  }

  return (
    <>
      <IconButton
        data-testid={`widget-alert-button--${widget?.id}`}
        size="small"
        onClick={() => setIsAlertDrawerOpen(true)}
        title={t('blox.dashboards.alerts.set_alert', { widgetTitle: widget?.title })}
        sx={{
          py: isKpi ? 0 : undefined,
          animation: isAlertPulsing ? ALERT_PULSE_ANIMATION : 'none',
        }}
      >
        <NotificationsNoneOutlinedIcon fontSize="small" />
      </IconButton>

      <WidgetAlerts
        open={isAlertDrawerOpen}
        onClose={() => setIsAlertDrawerOpen(false)}
        widget={widget}
      />
    </>
  );
};

export default WidgetAlertButton;
